// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"OrganizationSelection_blockClick_OF-og"};